<div class="withSpace">
    <div *ngIf="!getSubmittedDataHistory()" class="alert alert-info alert-dismissible">
        <button type="button" class="close" data-dismiss="alert">&times;</button>
        <strong>Info!</strong> No submitted data is available now; it will be shown after you click the SAVE button in preview or editor.
    </div>
    <div *ngIf="getSubmittedDataHistory()" class="alert alert-info alert-dismissible">
        <button type="button" class="close" data-dismiss="alert">&times;</button>
        Your submitted data
    </div>
    <textarea *ngIf="getSubmittedDataHistory()" [value]="getSubmittedDataHistory()" class="textAreaEditorComponent" [rows]="getRows()"></textarea>
</div>
